import { NgClass } from '@angular/common';
import { AfterViewInit, CUSTOM_ELEMENTS_SCHEMA, Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';

@Component({
  imports: [NgClass],
  selector: 'app-syndigo',
  standalone: true,
  templateUrl: './syndigo.component.html',
  styleUrls: ['./syndigo.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppSyndigoComponent implements AfterViewInit, OnDestroy {
  @Input() syndigoId: string | null = null;
  @ViewChild('syndigoPowePage') syndigoElement!: ElementRef;

  showSection: boolean = false;
  hasContent: boolean = true;

  ngAfterViewInit(): void {
    if (this.syndigoElement) {
      this.syndigoElement.nativeElement.addEventListener('content', this.checkSyndigoContent.bind(this));
    }
  }

  ngOnDestroy(): void {
    if (this.syndigoElement) {
      this.syndigoElement.nativeElement.removeEventListener('content', this.checkSyndigoContent.bind(this));
    }
  }

  private checkSyndigoContent(event: any): void {
    this.showSection = event.detail.hasContent;
    this.hasContent = event.detail.hasContent;
  }
}
